import { BundleType, PackageName, loadPackage } from '@foundation-player/builder';

type LoadPackagesOptions = {
  version: string;
  bundleType: BundleType;
  cdn?: string;
  isLocal?: boolean;
};

export function loadPackages(options: LoadPackagesOptions): Promise<void[]> {
  const packages: PackageName[] = [];

  if ([BundleType.ES5, BundleType.ES5Debug].includes(options.bundleType)) {
    packages.push(PackageName.Es5);
  }

  /**
   * If the loader is loaded from CDN or has been loaded on the current page before this will not load the loader again.
   * In these cases the global name window.foundation.loader already exists and prevents additional loading of the same package.
   * The version is not considered for this check, so the version might be different from the specified one.
   * But this is only a concern if you load via CDN AND define a different version in your LoaderConfig.
   */
  packages.push(PackageName.Loader, PackageName.Builder);

  return Promise.all(
    packages.map((packageName) =>
      loadPackage({
        packageName,
        bundleType: options.bundleType,
        version: options.version,
        cdn: options.cdn,
      }),
    ),
  );
}
